export default __webpack_public_path__ + "static/media/more.7b16b86c.svg";